(function () {
	lazyLoad();
    buttonCarouselInit();
    function buttonCarouselInit() {
      const mySwiper = new Swiper('.a-carousel-viewport', {
        loop: true,
        // navigation: {
        //   nextEl: ".a-carousel-left",
        //   prevEl: ".a-carousel-right",
        // }
      });

      [].concat(mySwiper).forEach(function (swiper) {
        const swiperWrap = $('.aplus-carousel-container').has($(swiper.el)); // 找到父级
        if (swiperWrap.find('.a-carousel-left')[0]) {
          swiperWrap.find('.a-carousel-left')[0].style.visibility = 'visible';
        }
        swiperWrap.find('.a-carousel-left').click(function () {
          swiper.slidePrev();
        });
        if (swiperWrap.find('.a-carousel-left a')[0]) {
          swiperWrap.find('.a-carousel-left a')[0].setAttribute('href', 'javascript:void(0)');
        }

        if (swiperWrap.find('.a-carousel-right')[0]) {
          swiperWrap.find('.a-carousel-right')[0].style.visibility = 'visible';
        }
        swiperWrap.find('.a-carousel-right').click(function () {
          swiper.slideNext();
        });
        if (swiperWrap.find('.a-carousel-right a')[0]) {
          swiperWrap.find('.a-carousel-right a')[0].setAttribute('href', 'javascript:void(0)');
        }

        swiperWrap.find('.aplus-goto-btn').click(function () {
          const index = $(this).index();
          swiper.slideTo(index, 500, false); //切换到第一个slide，速度为500ms
		  console.log("index===========", index);
        });

        swiperWrap.find('.aplus-pagination-dot').click(function () {
          const index = $(this).index();
          swiper.slideTo(index, 500, false); //切换到第一个slide，速度为500ms
        });

        swiper.on('slideChange', function (event) {
          let index = event.realIndex;
          swiperWrap.find(`.aplus-goto-btn`).removeClass('aplus-active');
          swiperWrap.find(`.aplus-goto-btn:eq(${index})`).addClass('aplus-active');
          swiperWrap.find(`.aplus-pagination-dot > .carousel-slider-circle`).removeClass('aplus-carousel-active');
          swiperWrap
            .find(`.aplus-pagination-dot:eq(${index})`)
            .find('.carousel-slider-circle')
            .addClass('aplus-carousel-active');
        });
      });
    }
    function lazyLoad() {
      var lazyImages = [].slice.call(document.querySelectorAll('img.a-lazy-loaded'));
      if ('IntersectionObserver' in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              let lazyImage = entry.target;
              console.log(lazyImage.dataset.src);
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.classList.remove('a-lazy-loaded');
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });
        lazyImages.forEach(function (lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        // Possibly fall back to a more compatible method here
      }
    }
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
	});

	initProductAccordion();
})();
